

document.querySelectorAll( '.reviews-slider' ).forEach( section => {
    const slider = section.querySelector( '.reviews-slider__slides' );
    const nextArrow = section.querySelector( '.next' );
    const prevArrow = section.querySelector( '.prev' );
    jQuery( slider ).slick( {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        prevArrow,
        nextArrow,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]

    } );
} );